import React from 'react';
import PropTypes from 'prop-types';

import {Box, Chip, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

const Skills = (props) => {
  const {
    onSkillsChange,
    skills,
  } = props;

  // Predefined list of caregiving skills
  const skillsOptions = Object.keys(translate('caregiverScreening.SkillsAndLanguages.AvailableSkills'));

  const handleSkillToggle = (skill) => {
    const updatedItems = skills.includes(skill) ?
      skills.filter((s) => s !== skill) :
      [...skills, skill];
    onSkillsChange(updatedItems);
  };

  return (
    <>
      <Typography variant="h6" gutterBottom align='center' fontWeight={600} sx={{mt: 3}}>
        <Translate expression='caregiverScreening.SkillsAndLanguages.SkillsServicesTitle'/>
      </Typography>
      <Typography variant="body2" color="text.secondary" align='center'>
        <Translate expression='caregiverScreening.SkillsAndLanguages.SkillsServicesSubtitle'/>
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: 1,
          mt: 2,
        }}
      >
        {
          skillsOptions.map((skill) => {
            const isSkillSelected = skills.includes(skill);
            return (
              <Chip
                key={skill}
                label={translate(`caregiverScreening.SkillsAndLanguages.AvailableSkills.${skill}`)}
                onClick={() => handleSkillToggle(skill)}
                color={isSkillSelected ? 'primary' : 'default'}
                variant={isSkillSelected ? 'filled' : 'outlined'}
                sx={{
                  'cursor': 'pointer',
                  'transition': 'all 0.2s ease-in-out',
                  'boxShadow': isSkillSelected ? 2 : 0,
                  '&:hover': {
                    transform: 'translateY(-1px)',
                    boxShadow: 2,
                  },
                }}
              />
            );
          })
        }
      </Box>
    </>
  );
};

Skills.propTypes = {
  onSkillsChange: PropTypes.func.isRequired,
  skills: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Skills;
